import { Theme } from '@mds/web-ui-theme';
import { Link } from '@mds/web-ui-link';
import styles from './PageLoadErrorDisplay.module.scss';
import SpotBox from '../../Spot - Box.svg';

const DEFAULT_MESSAGE = (
  <>
    Oops! Something went wrong and the page didn&apos;t load. Please check back later.
    {' '}If the problem continues, let us know at{' '}
    <Link
      data-testid="mds-email-support-link-clp"
      id="mds-email-support-link-clp"
      href="mailto:correspondent.application.support@chase.com"
      target="_blank"
      textDecoration={['underline']}
      textStyle="bodyLarge"
    > correspondent.application.support@chase.com
    </Link>
    .
  </>
);

function PageLoadErrorDisplay({ message }: { message?: string }) {
  const displayMessage = message ?? DEFAULT_MESSAGE;

  return (
    <Theme>
      <div className={styles.pageLoadErrorDisplayBackground}>
        <div className={styles.pageLoadErrorDisplayTopLayer} />
        <div className={styles.pageLoadErrorDisplay}>
          <img
            src={SpotBox}
            alt="Box illustration"
            width={148}
            height={148}
            className={styles.pageLoadErrorDisplayImage}
          />
          <p className={styles.pageLoadErrorDisplayText}>
            {displayMessage}
          </p>
        </div>
      </div>
    </Theme>
  );
}

export default PageLoadErrorDisplay;
